import React from 'react';
import {ButtonBar, SaveButton, Field, Form, Option, Split} from '../commons/Forms.js';
import {Pane, Part} from '../commons/Panes';
import {connect} from 'react-redux';
import {modifySkiresort} from '../../redux/skiresorts/actions';
import ReactSpinner from 'react-spinjs';
import moment from 'moment';
import '../../styles/adminPanels.less';
import {validateEmail} from '../../utils';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';


/** Panneau d'édition de la station en cours */
@connect(
  state => ({user: state.user}),
  {modifySkiresort}
)
class SkiresortEdit extends React.Component {

  async onSubmit(e) {
    e.preventDefault();

    let user = this.props.user;
    let skiresort = user.selectedSkiresort;

    let data = {
      id: skiresort.id,
      country: this.refs.country.value(),
      logoUrl: this.refs.logoUrl.value(),
      name: this.refs.name.value(),
      latitude: +this.refs.latitude.value(),
      longitude: +this.refs.longitude.value(),
      openingDate: this.refs.openingDate.value(),
      closingDate: this.refs.closingDate.value(),
      assignees: this.refs.assignees.value(),
      messageJustificationFeature: (this.refs.messageJustificationFeature.value() === 'true'),
      deleteBeacon: this.state.sendDeleteBeacon,
      deleteArea: this.state.sendDeleteArea,
      csvBeacon: null,
      csvArea: null
    };

    this.setState({
      editBeacon: false,
      sendDeleteBeacon: false,
      editArea: false,
      sendDeleteArea: false
    });

    if (this.refs.csvBeacon !== undefined && this.refs.csvBeacon.value() !== undefined) {
      data.csvBeacon = await this.csvToBase64(this.refs.csvBeacon.value());
    }
    if (this.refs.csvArea !== undefined && this.refs.csvArea.value() !== undefined) {
      data.csvArea = await this.csvToBase64(this.refs.csvArea.value());
    }

    this.props.modifySkiresort(data);
  }

  csvToBase64(csvFile) {
    let reader = new FileReader();
    return new Promise((resolve) => {
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(csvFile);
    });
  }

  constructor() {
    super();
    this.state = {
      editBeacon: false,
      sendDeleteBeacon: false,
      editArea: false,
      sendDeleteArea: false
    };
  }

  render() {
    let user = this.props.user;
    let skiresort = user.selectedSkiresort;

    // création dynamique du champs d'édition des points d'ancrage
    var beaconsEditor = null;
    if (this.state.editBeacon || !skiresort.has_beacons) {
      const onBackClickEvt = e => {
        e.preventDefault();
        this.setState({
          editBeacon: false,
          sendDeleteBeacon: false
        });
      };
      let backBtn = null;
      if (skiresort.has_beacons) {
        backBtn = <button onClick={onBackClickEvt} className="kmz-edit">Annuler la modif des points</button>;
      }
      beaconsEditor = (<div>
        <Field ofType="file" label="CSV des points d'ancrage" required={false} ref="csvBeacon"/>
        <i className="notice">Pour voir les points d'ancrage à jour il faudra recharger la page</i>
        {backBtn}
      </div>);
    } else {
      const onEditClickEvt = e => {
        e.preventDefault();
        this.setState({
          editBeacon: true,
          sendDeleteBeacon: true
        });
      };
      beaconsEditor = (
        <div>
          <button onClick={onEditClickEvt} className="kmz-edit">Modifier les points d'ancrage</button>
        </div>
      );
    }

    // création dynamique du champs d'édition des zones
    var areasEditor = null;
    if (this.state.editArea || !skiresort.has_areas) {
      const onBackClickEvt = e => {
        e.preventDefault();
        this.setState({
          editArea: false,
          sendDeleteArea: false
        });
      };
      let backBtn = null;
      if (skiresort.has_areas) {
        backBtn = <button onClick={onBackClickEvt} className="kmz-edit">Annuler la modif des zones</button>;
      }
      areasEditor = (<div>
        <Field ofType="file" label="CSV des zones" required={false} ref="csvArea"/>
        <i className="notice">Pour voir les zones à jour il faudra recharger la page</i>
        {backBtn}
      </div>);
    } else {
      const onEditClickEvt = e => {
        e.preventDefault();
        this.setState({
          editArea: true,
          sendDeleteArea: true
        });
      };
      areasEditor = (
        <div>
          <button onClick={onEditClickEvt} className="kmz-edit">Modifier les zones</button>
        </div>
      );
    }

    let theForm = (
      <Form onSubmit={e => this.onSubmit(e)}>
        <Field ofType="select" label="Pays" required={true} value={skiresort.country} ref="country">
          <Option value="Italie"/>
          <Option value="France"/>
          <Option value="Suisse"/>
        </Field>
        <Field ofType="textarea" label="URL (ou base64) du logo" required={false} value={skiresort.logoUrl} ref="logoUrl"/>
        <OverlayTrigger overlay={
          <Tooltip id="tooltip" className='tooltip'>
            <span>Une image encod&eacute;e en base 64 doit commencer par `data:image/&lt;format-de-l'image&gt;;base64`. Vous pouvez vous aider de convertisseur d'image en base64 en ligne.</span>
          </Tooltip>
        } placement="left">
          <i className="notice">Qu'est-ce qu'une base64 ?</i>
        </OverlayTrigger>
        <Field ofType="text" label="Nom" required={true} value={skiresort.name}
               validateWith="min3" ref="name"/>
        <Split>
          <Field ofType="text" label="Latitude" required={false}
                 value={skiresort.latitude}
                 validateWith="latitude" ref="latitude"/>
          <Field ofType="text" label="Longitude" required={false}
                 value={skiresort.longitude}
                 validateWith="longitude" ref="longitude"/>
        </Split>
        <Field ofType="textarea" label="Responsables" required={false}
               value={skiresort.assignees} ref="assignees"
               validateWith={(data) => data.split('\n').every(m => validateEmail(m))}
               validationError="Veuillez entrer une adresse e-mail valide"/>

        {beaconsEditor}
        {areasEditor}

        <Split>
          <Field ofType="date" label="Ouverture" required={true}
                 value={moment(skiresort.openingDate).format('YYYY-MM-DD')}
                 ref="openingDate"/>
          <Field ofType="date" label="Fermeture" required={true}
                 value={moment(skiresort.closingDate).format('YYYY-MM-DD')}
                 ref="closingDate"/>
        </Split>


        <Field ofType="select" label="Justification des alertes" required={false} value={skiresort.messageJustificationFeature ? 'true' : 'false'} ref="messageJustificationFeature">
          <Option value="true" label="Activée"/>
          <Option value="false" label="Desactivée"/>
        </Field>

        <ButtonBar>
          <SaveButton/>
        </ButtonBar>
      </Form>
    );

    return (
      <Pane title="Edition de la station">
        <Part title="Station">
          {user.selectedSkiresortIsUpdating ? <ReactSpinner/> : theForm}
        </Part>
      </Pane>
    )
  }
}


export default SkiresortEdit;



// WEBPACK FOOTER //
// ./src/components/admin/SkiresortEdit.js